export default "__VITE_ASSET__Ddf2VOEx__"